export default __webpack_public_path__ + "static/media/universityIcon.3c282b50.svg";